import { Http } from '@mygpt/app/http';

export interface DeleteFAQsParams {
  // 数据集 ID
  datasetId: string;
  faqsId: string;
}

/**
 * 删除问答
 * @param params
 * @returns
 */
export const deleteFAQsService = (params: DeleteFAQsParams) => {
  const { datasetId, faqsId } = params;
  const { delete: deleteFn } = Http.use();
  return deleteFn(`/datasets/${datasetId}/faqs/${faqsId}?faq_id=${faqsId}`);
};

export interface BatchDeleteFAQsParams {
  // 数据集 ID
  datasetId: string;
  faqsIds: string[];
}

export const batchDeleteFAQsService = (params: BatchDeleteFAQsParams) => {
  const { datasetId, faqsIds } = params;
  const { delete: _delete } = Http.use();
  return _delete(`/datasets/${datasetId}/faqs/batch`, {
    params: {
      faqs_ids: faqsIds.join(','),
    },
  });
};
